import React from "react";
import { Box, Typography } from "@mui/joy";
import { FileDown, RotateCw } from "lucide-react";
import { useParams } from "react-router-dom";

import { useDocument, useAsset } from "../../../hooks/query";
import { useNotification } from "../../../hooks/useNotification";
import { DocumentPreviewWidget } from "../../";
import { useClaimsEstimate } from "./hooks";

export function ClaimsEstimateReport() {
    const { id: projectId } = useParams();
    const { claimsEstimateDocument, refreshClaimsEstimate } = useClaimsEstimate();
    const { useClaimsEstimateCreate } = useDocument();
    const { useDownload } = useAsset();
    const { showSuccess, showError } = useNotification();

    const generateClaimsEstimateSvc = useClaimsEstimateCreate();
    const downloadAssetSvc = useDownload();

    const handleDownloadClaimsEstimate = async () => {
        try {
            if (!projectId) {
                showError("Project ID not found");
                return;
            }
            const data = await generateClaimsEstimateSvc.mutateAsync({ ProjectId: projectId });

            if (data?.assetId) {
                await downloadAssetSvc.mutateAsync({ AssetId: data.assetId });
                showSuccess("Claims Estimate downloaded successfully");
            } else {
                showError("Failed to generate download link");
            }

            setTimeout(() => {
                refreshClaimsEstimate();
            }, 1000);
        } catch (error) {
            console.error("Error downloading claims estimate:", error);
            showError("Failed to download claims estimate");
        }
    };

    return (
        <DocumentPreviewWidget
            thumbnailUrl={claimsEstimateDocument?.thumbnailUrl}
            title="Claims Estimate"
            description="Itemized report for insurance claims"
            status={claimsEstimateDocument?.Status || "NOT GENERATED"}
            assetId={claimsEstimateDocument?.DocumentAssetId}
            buttonText={claimsEstimateDocument ? "Download" : "Generate Estimate"}
            buttonIcon={<FileDown size={16} />}
            onButtonClick={!claimsEstimateDocument ? handleDownloadClaimsEstimate : undefined}
            loading={generateClaimsEstimateSvc.isPending}
            menuActions={
                claimsEstimateDocument
                    ? [
                            {
                                label: "Regenerate",
                                icon: <RotateCw size={16} />,
                                onClick: handleDownloadClaimsEstimate,
                                disabled: generateClaimsEstimateSvc.isPending,
                            },
                        ]
                    : []
            }
        />
    );
}
